import { render, staticRenderFns } from "./AiGeneratedLabel.vue?vue&type=template&id=376644c4&scoped=true"
import script from "./AiGeneratedLabel.vue?vue&type=script&lang=ts"
export * from "./AiGeneratedLabel.vue?vue&type=script&lang=ts"
import style0 from "./AiGeneratedLabel.vue?vue&type=style&index=0&id=376644c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376644c4",
  null
  
)

export default component.exports